<template>
    <div class="about-bcn" v-if="pageSetup != null" id="bcn">
        <div class="container">
            <div class="bcn-logo-title">
                <img :src="pageSetup.about_bcn.logo_bcn" alt="" class="logo">
                <h2>{{ pageSetup.about_bcn.bcn_title }}</h2>
            </div>
            <div class="column-container" v-if="!isMobileChecker">
                <div class="col-left">
                    <div class="col-info">
                        <h3>{{ pageSetup.about_bcn.desc_title }}</h3>
                        <div class="col-desc" v-html="pageSetup.about_bcn.desc"></div>
                    </div>
                </div>
                <div class="col-right">
                    <div class="col-img"><img :src="pageSetup.about_bcn.img" alt=""></div>
                </div>
            </div>
            <div class="col-info-mobile" v-if="isMobileChecker">
                <div class="inner-content">
                    <h3>{{ pageSetup.about_bcn.desc_title }}</h3>
                    <div class="col-desc col-desc-up" v-html="pageSetup.about_bcn.desc"></div>
                    <div class="col-img col-img-mobile">
                        <img :src="pageSetup.about_bcn.img" alt="">
                    </div>
                    <div class="col-desc col-desc-down" v-html="pageSetup.about_bcn.desc"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'about-bcn-section',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadAboutPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-bcn.scss';
    @import '@/styles/components/about-page/respond/about-bcn-respond.scss';
</style>